module.exports = __webpack_public_path__ + "static/media/comment-alt-check.1b3e0de4.svg";